var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',{attrs:{"index":_vm.index}},[_c('router-link',{staticClass:"menu-router-link",attrs:{"to":_vm.route}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }